module.exports = __webpack_public_path__ + "media/images/icons/outlined/console-sql-243361d9f6ff49e336541d11528546d7.svg";